'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var runWhile = require('../fp/run-while.js');

const walkListItemRecord = (callback, config) => {
    const { items, startId, initValue } = config;
    const visited = new Set();
    const totalNodes = Object.keys(items).length;
    const { result } = runWhile.runWhile({
        iterationLimit: totalNodes + 1,
        initialValue: {
            currentId: startId,
            accumulator: initValue,
            control: {
                stop: false,
            },
        },
        predicate: ({ control, currentId }) => {
            const stop = control === null || control === void 0 ? void 0 : control.stop;
            const forcedStop = stop === undefined ? false : stop;
            /**
             * Stop early or when the end is reached
             */
            return !forcedStop && currentId !== null;
        },
        callback: (current) => {
            if (visited.has(current.currentId)) {
                throw new Error('Infinite loop found');
            }
            visited.add(current.currentId);
            const currentItem = items[current.currentId];
            if (!currentItem) {
                throw new Error('Cul de sac detected');
            }
            const { result: currentResult, control } = callback(current.accumulator, currentItem);
            return {
                accumulator: currentResult,
                currentId: currentItem.nextId,
                control,
            };
        },
    });
    return result.accumulator;
};
const findPreviousId = (id, list) => {
    if (id === list.headId) {
        return null;
    }
    return walkListItemRecord((acc, current) => {
        if (current.nextId === id) {
            return {
                result: current.id,
                control: {
                    stop: true,
                },
            };
        }
        return {
            result: acc,
        };
    }, {
        initValue: null,
        startId: list.headId,
        items: list.items,
    });
};
const assertItemCompatibility = (item, format) => {
    /**
     * An empty linked list won't have any format yet, it will be
     * determined by the first item inserted in the list.
     */
    if (format === null) {
        return;
    }
    const incompatibleWithDoubleLinks = item.previousId === undefined && format === 'double';
    const incompatibleWithSingleLink = item.previousId !== undefined && format === 'single';
    if (incompatibleWithDoubleLinks || incompatibleWithSingleLink) {
        throw new Error(`Node is incompatible with the list (id: ${item.id})`);
    }
};
const assertPresence = (id, items) => {
    if (id && !items[id]) {
        throw new Error(`Node not found in the list (id: ${id})`);
    }
};
const assertNewNodePosition = (item, config) => {
    const { previousId, list } = config;
    const insertionMiddleError = previousId && list.items[previousId].nextId !== item.nextId;
    const insertionTailError = previousId && item.nextId === null && list.items[previousId].nextId !== null;
    const insertionHeadError = previousId === null && item.nextId !== list.headId;
    if (insertionMiddleError || insertionTailError || insertionHeadError) {
        throw new Error(`Invalid position for given node (id: ${item.id})`);
    }
};

exports.assertItemCompatibility = assertItemCompatibility;
exports.assertNewNodePosition = assertNewNodePosition;
exports.assertPresence = assertPresence;
exports.findPreviousId = findPreviousId;
exports.walkListItemRecord = walkListItemRecord;
//# sourceMappingURL=linked-list-utils.js.map
